import React from 'react';
import { Link } from 'react-router-dom';

const ForgotIdPage: React.FC = () => (
  <div style={styles.page}>
    <div style={styles.card}>
      <h1 style={styles.title}>Forgot ID (Email)</h1>
      <p style={styles.sub}>
        Your ID is the email address you used when signing up.
      </p>
      <div style={styles.infoBox}>
        <div style={{ fontWeight: 600, marginBottom: 8 }}>Can't remember your email?</div>
        <p style={{ fontSize: 13, color: '#555', lineHeight: 1.7, margin: 0 }}>
          Contact our customer support team with your registered name and phone number
          and we'll help you locate your account.
        </p>
        <a href="mailto:support@moashops.com" style={styles.emailLink}>
          support@moashops.com
        </a>
      </div>
      <Link to="/login" style={styles.back}>Back to Login</Link>
    </div>
  </div>
);

const styles: Record<string, React.CSSProperties> = {
  page: { minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fafafa' },
  card: { background: '#fff', padding: '48px 40px', borderRadius: 16, width: '100%', maxWidth: 420, boxShadow: '0 4px 24px rgba(0,0,0,0.06)', textAlign: 'center' },
  title: { fontSize: 24, fontWeight: 700, color: '#333', marginBottom: 8 },
  sub: { fontSize: 13, color: '#999', marginBottom: 28, lineHeight: 1.6 },
  infoBox: { background: '#fafafa', border: '1px solid #f0f0f0', borderRadius: 10, padding: '20px 24px', marginBottom: 28, textAlign: 'left' },
  emailLink: { display: 'inline-block', marginTop: 12, color: '#b39ddb', fontWeight: 600, fontSize: 14, textDecoration: 'none' },
  back: { color: '#aaa', fontSize: 13, textDecoration: 'none' },
};

export default ForgotIdPage;
